/*  MUI  */
import { Avatar, Box, Button, Typography } from '@mui/material';

/*  Shared  */
import { Notify } from 'application/Shared/Helpers';
import Core from 'application/Shared/Helpers/Functions';
import { Modal, ModalBody, ModalFooter } from 'application/Shared/Modals';
import { debug } from 'application/Shared/Utils';

/* Yarn */
import axios from 'axios';
import Session from 'objects/Session';

/* Objects */
import { User, UserIcon } from 'objects/User';

/* React */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class UserProfileImageChange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openPicture: false,
            photoSelected: false
        };
        this.fileInput = React.createRef();
    }

    async handleProfileChange(event) {
        const { callbackFn, session, setSessionInfo, t } = this.props;
        event.preventDefault();
        if (this.fileInput.current.files[0]) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const payload = {
                    id: session.id,
                    imagePayload: {
                        data: btoa(e.target.result),
                        type: this.fileInput.current.files[0].type
                    }
                };

                const response = await axios.put('/user/self', payload);
                if (Core.isset(response, 'data', 'data', 'id')) {
                    try {
                        const userSession = await Session.getSessionInfo();
                        setSessionInfo(userSession);
                        this.setState({
                            openPicture: false,
                            photoSelected: false
                        });
                        if (callbackFn) {
                            callbackFn();
                        }
                        Notify.success(t('UserProfileImageChange.success'));
                    } catch (err) {
                        debug.e('UserProfileImageChange failed', err);
                    }
                }
            };
            reader.readAsDataURL(this.fileInput.current.files[0]);
        }
    }

    async handleProfileImageSelect() {
        if (this.fileInput.current.files[0]) {
            const reader = new FileReader();
            reader.onload = async () => {
                this.setState({
                    photoSelected: true
                });
            };
            reader.readAsDataURL(this.fileInput.current.files[0]);
        }
    }

    renderModal = () => {
        const { session, t } = this.props;
        const { openPicture, photoSelected } = this.state;

        return (
            <Modal
                onClose={() => {
                    this.setState({
                        openPicture: false,
                        photoSelected: false
                    });
                }}
                open={openPicture}
                aria-labelledby="change-your-profile-image-modal"
                data-testid="userProfileImageChangeModal"
                title={t('UserProfileImageChange.title_descriptive')}
            >
                <form onSubmit={(e) => this.handleProfileChange(e)}>
                    <ModalBody>
                        <Typography variant="body2">
                            {t('UserProfileImageChange.description')}
                        </Typography>
                        <User data={session}>
                            <Button
                                color="primary"
                                variant="outlined"
                                component="label"
                                style={{ marginTop: '8px' }}
                                disabled={photoSelected}
                            >
                                {!photoSelected && <UserIcon noLink noFloat />}

                                {photoSelected
                                    ? t(
                                          'UserProfileImageChange.new_photo_selected'
                                      )
                                    : t(
                                          'UserProfileImageChange.select_new_photo'
                                      )}

                                <input
                                    ref={this.fileInput}
                                    type="file"
                                    accept="image/*"
                                    onChange={() => {
                                        this.handleProfileImageSelect();
                                    }}
                                    style={{ display: 'none' }}
                                />
                            </Button>
                        </User>
                        <br />
                        &nbsp;
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    openPicture: false,
                                    photoSelected: false
                                });
                            }}
                            variant="outlined"
                            color="primary"
                        >
                            {t('Common.cancel')}
                        </Button>

                        {photoSelected && (
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                {t('UserProfileImageChange.upload_new_photo')}
                            </Button>
                        )}
                    </ModalFooter>
                </form>
            </Modal>
        );
    };

    render() {
        const { avatar, style, t } = this.props;
        const { image, openPicture } = this.state;

        return (
            <Box
                display="flex"
                alignItems="center"
                data-trackid="userProfileImageChangeRender"
            >
                {avatar && (
                    <Avatar
                        style={{ ...style, marginRight: '8px' }}
                        src={image.src}
                    />
                )}
                <Button
                    variant="outlined"
                    color="primary"
                    size="anmSmall"
                    data-testid="userProfileImageChangeBtn"
                    onClick={() => {
                        this.setState({ openPicture: true });
                    }}
                >
                    {t('UserProfileImageChange.title')}
                </Button>
                {openPicture && this.renderModal()}
            </Box>
        );
    }
}

export default withTranslation()(UserProfileImageChange);
